export default __webpack_public_path__ + "static/media/vivodeco1.6ddf799d.jpg";